import styled from 'styled-components';

import colors from '@/design/colors';
import { HeadingSmall } from '@/design/typography';
import { dashedBorder } from '@/design/borders';

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 8px;

  width: 100%;
  padding: 10px;
  border-radius: 4px;

  color: ${colors.gray100};
  position: relative;

  ${dashedBorder({
    borderRadius: 4,
    dashArray: '7, 7',
    lineCap: 'square',
    color: colors.gray100,
    strokeWidth: 3,
  })}

  ${HeadingSmall(14)};

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${colors.purple100};

    ${dashedBorder({
      borderRadius: 4,
      dashArray: '7, 7',
      lineCap: 'square',
      color: colors.purple100,
      strokeWidth: 3,
    })}

    background-color: ${colors.purple50};
  }

  &:disabled {
    color: ${colors.gray50};

    ${dashedBorder({
      borderRadius: 4,
      dashArray: '7, 7',
      lineCap: 'square',
      color: colors.gray50,
      strokeWidth: 3,
    })}
  }
`;
